

















import Vue, { PropType } from 'vue';
import type { ISilo } from '@/types/ISilo';

export default Vue.extend({
  name: 'ClearanceButton',
  props: {
    silo: {
      type: Object as PropType<ISilo>,
      required: true,
    },
    isFanClearance: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data: () => {
    return {
      showButton: false,
      success: undefined as boolean | undefined,
      loading: false,
    };
  },
  computed: {
    bitSet(): boolean {
      return this.isFanClearance ? this.silo.fanClearanceBitSet : this.silo.clearanceBitSet;
    },
    label(): string {
      return this.isFanClearance ? 'Freigeben Gebläse' : 'Freigeben Bordluft';
    },
  },
  methods: {
    async sendClearance(siloNumber: number): Promise<void> {
      this.success = undefined;
      this.loading = true;

      try {
        if (this.isFanClearance) {
          await this.$siloService.sendFanClearance(siloNumber);
        } else {
          await this.$siloService.sendClearance(siloNumber);
        }
        this.success = true;
      } catch {
        this.success = false;
      } finally {
        setTimeout(() => (this.success = undefined), 3000);
        this.loading = false;
      }
    },
  },
});
